







import Vue from 'vue';
import MapView from "./components/Map.vue";

export default Vue.extend({
	name: 'app',

	components: {
		MapView
	},

	computed: {

		fill():boolean {
			return location.search.indexOf("dev") != 1;
		}

	}


});
